var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"lazy-script",rawName:"v-lazy-script",value:({ name: 'jebbit', src: _vm.src }),expression:"{ name: 'jebbit', src }"}],on:{"loaded":_vm.scriptLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }